module.exports = __webpack_public_path__ + "static/media/9bHjJNbY.407de4c0.jpg";